<p>
  locuri-consum-operator works!
</p>
